module.exports = __webpack_public_path__ + "img/ocultar_menu.0bd3a0a3.svg";